import envs from "../envs";

export const paraSeuNegocio = `${envs.publicUrl}/pj/mei/Paginas/microempreendedor-individual.aspx`;
export const sobreEmpresa = `${envs.publicUrl}/Sobre-a-empresa/Paginas/home-sobre-a-empresa.aspx`;
export const sobreSeguranca = `${envs.publicUrlSharePoint}/Sobre-a-empresa/Paginas/Seguranca.aspx`;
export const portalPrivacidade = `https://csh.my.site.com/portalprivacidade`;
export const cancelamentoContratos = `${envs.publicUrl}/paravoce/seguros/Paginas/Cancelamentos.aspx`;
export const enderecos = `${envs.publicUrl}/atendimento/Paginas/Enderecos.aspx`;
export const atendimentoPorTelefone = `${envs.publicUrl}/atendimento/Paginas/Telefones.aspx`;
export const areaLogada = `${envs.hostAreaLogada}/login`;
export const areaLogadaCadastro = `${envs.hostAreaLogada}/perfil/criar`;
export const areaLogadaJV5 = `${envs.hostAreaLogadaJv5}/login`;
export const areaLogadaJV5Consorcio = `${envs.hostAreaLogada}/login/consorcio`;
export const areaLogadaSaude = `${envs.hostSiteSeguroSaude}/site/default.aspx`;
export const areaLogadaOdontologico = `${envs.hostSitSeguroOdontologico}/ConnectOdontoWeb/websegurado-index-login.action`;
export const superXCap = `${envs.hostSuperXCap}`;
export const CnpNovaMarca = "https://cnpcapitalizacao.com.br/nossa-nova-marca";
export const SeguroEmpresarial =
  "https://www.caixaseguradora.com.br/pj/mge/Paginas/Seguro-Empresarial.aspx";

export const atendimento = `/atendimento`;

export const sharepoint = "https://portal.caixaseguradora.com.br";

export * as capitalizacao from "./capitalizacao";
export * as consorcio from "./consorcio";
export * as capaluguel from "./capaluguel";
export * as habitacional from "./habitacional";
export * as residencial from "./residencial";
export * as empresarial from "./empresarial";
export * as saude from "./saude";
export * as sobreNos from "./sobreNos";
export * from "./menubar";
